import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
interface PdfDisclaimersProps {
  data: any;
}

export const PdfDisclaimers: React.FC<PdfDisclaimersProps> = () => {
  const styles = StyleSheet.create({
    text: {
      fontSize: '8.5px',
      lineHeight: 1.5,
    },
    leftColumn: {
      flexDirection: 'row'
    },
    row: {
      width: '100%'
    },
    bannertext: {
      fontSize: '14px',
      backgroundColor: '#ebf9fb',
      marginBottom: '7px',
      color: '#298d9c',
      padding: '2.5px 2.5px 2.5px 5px',
      fontFamily: 'Libre Franklin Bold',
      borderBottom: '1px solid #288C9C',
      borderTop: '1px solid #288C9C'
    }
  });

  return (
    <View style={styles.leftColumn}>
      <View style={styles.row}>
        <Text style={styles.bannertext}>Disclaimers</Text>
        <View>
          <Text style={[styles.text, {paddingBottom: 7}]}>
            This report is intended only for the report recipient (the entity to which the report is issued). Any reproduction, transfer, distribution, or other dissemination
            for use other than by the report recipient is strictly prohibited and could result in legal action.
          </Text>

          <Text style={[styles.text, {paddingBottom: 7}]}>
            This report is valid only if obtained by the report recipient directly from ECFMG, a division of Intealth. ECFMG makes no claims about the authenticity of any
            Verification Status Report not obtained by the report recipient directly from ECFMG. The use of the term “VERIFIED” indicates that ECFMG has authenticated a health
            professional’s credential as indicated in this report through ECFMG’s primary-source verification process. This includes the authentication of the credential by
            the issuing authority, which ECFMG does not control. ECFMG does not guarantee, certify, or assure that such verification is accurate. ECFMG makes no
            recommendations or endorsements of health professionals.
          </Text>

          <Text style={[styles.text, {paddingBottom: 7}]}>
            If the credential was submitted to ECFMG in a language other than English, the health professional was required to include a certified English translation of the
            document. That translation, if applicable, is included for your reference; ECFMG does not verify the content of the translation and makes no endorsement of the
            agency or company that prepared the translation.
          </Text>

          <Text style={[styles.text, { fontFamily: 'Libre Franklin Bold', marginBottom: 16 }]}>
            For more information on ECFMG Credential Verification for Health Professionals, please contact us at{' '}
            <Text style={{ color: '#5F9EA0', textDecoration: 'underline' }}>cvhpinfo@ecfmg.org</Text>.
          </Text>
        </View>
      </View>
    </View>
  );
};
export default PdfDisclaimers;
